<template>
  <div>
    <datepicker
        input-class="form-control"
        :language="hr"
        :format="customFormatter"
        v-model="selectedDate"
    ></datepicker>
    <input type="hidden" :name="name" :value="selectedDateFormatted">
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import {hr} from "vuejs-datepicker/src/locale";
import moment from 'moment'

export default {
  name: "VueDatePicker",

  props: [
      'name',
      'value'
  ],

  components: {
    Datepicker,
  },

  created() {
    if (this.value) {
      this.selectedDate = this.value
    }
  },

  data() {
    return {
      hr: hr,
      selectedDate: null,
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD.MM.YYYY');
    }
  },
  computed: {
    selectedDateFormatted() {
      return moment(this.selectedDate).format('YYYY-MM-DD');
    }
  }
}
</script>
